import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inventory from "@/pages/Inventory";
import Services from "@/pages/Services";
import Quotes from "@/pages/Quotes";
import Invoices from "@/pages/Invoices";
import ItemMasters from "@/pages/ItemMasters";
import Staff from "@/pages/Staff";
import DeliveryLabel from "@/pages/DeliveryLabel";
import Expenses from "@/pages/Expenses";
import ServiceReceipt from "@/pages/ServiceReceipt";
import QuoteReceipt from "@/pages/QuoteReceipt";
import InvoiceReceipt from "@/pages/InvoiceReceipt";
import Notifications from "@/pages/Notifications";
import Customers from "@/pages/Customers";
import Settings from "@/pages/Settings";

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/services/:id/print"
              element={<ProtectedRoute><ServiceReceipt /></ProtectedRoute>}
            />
            <Route
              path="/quotes/:id/print"
              element={<ProtectedRoute><QuoteReceipt /></ProtectedRoute>}
            />
            <Route
              path="/invoices/:id/print"
              element={<ProtectedRoute><InvoiceReceipt /></ProtectedRoute>}
            />
            <Route
              path="/"
              element={<ProtectedRoute><Layout /></ProtectedRoute>}
            >
              <Route index element={<Dashboard />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="sales" element={<Navigate to="/inventory" replace />} />
              <Route path="customers" element={<Customers />} />
              <Route path="services" element={<Services />} />
              <Route path="quotes" element={<Quotes />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="item-masters" element={<ItemMasters />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="staff" element={<Staff />} />
              <Route path="delivery" element={<DeliveryLabel />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="settings" element={<AdminOnly><Settings /></AdminOnly>} />
            </Route>
          </Routes>
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
